import { HTTP } from '../../utils'

export const populatePlanningStream = () => {
  return HTTP().get('/entity/planningstream')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}
/*
export const populatePlanningStreamWithStructure = (userId) => {
  let url = '/entity/planningstream?isPopulateStructure=true'
  if (userId)
    url += '&userId=' + userId
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}
*/
export const populateStreamWithStructure = (programCode, userId) => {
  let url = '/entity/program/'+programCode+'?isPopulateStructure=true'
  if (userId)
    url += '&userId=' + userId
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getStreamLeafForCourse = (programCode, originUuid) => {
  let url = '/entity/program/'+programCode+'/leaf/'+originUuid
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const populateStreamWithStructureSummary = (programCode, userId) => {
  let url = '/entity/program/'+programCode+'/summary?isPopulateStructure=true'
  if (userId)
    url += '&userId=' + userId
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const populateQuickLinks = (type) => {
  return HTTP().get('quicklink?type='+type)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const populateCompletedQuests = () => {
  return HTTP().get('/competency/completedquests')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const populateContinueQuestAction = () => {
  return HTTP().get('/suggest/lastaction')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const populateOwnedCourses = (pagingOptions) => {
  const ownerId = localStorage.getItem('userid')
  const url = 'deliverycontext/myCourses?ownerId=' + ownerId + '&page=' + pagingOptions.page + '&count=' + pagingOptions.count
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const populateEnrolledCourses = (pagingOptions) => {
  const url = 'deliverycontext/enrolled?page=' + pagingOptions.page + '&count=' + pagingOptions.count
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const populateSupervisorCourses = (pagingOptions) => {
  const url = 'deliverycontext/supervisor?page=' + pagingOptions.page + '&count=' + pagingOptions.count
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const populateSupersupervisorCourses = (pagingOptions) => {
  const url = 'deliverycontext/supersupervisor'
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const populateEventRecommendations = () => {
  return HTTP().get('/event/recommendEvent')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const populateJobRecommendations = () => {
  return HTTP().get('/job/recommendJobs')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const populateClubRecommendations = () => {
  return HTTP().get('/club/recommendClub')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getPersonProfile = (userId) => {
  return HTTP().get('/person/findByUserId/' + userId)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getAdminReport = () => {
  return HTTP().get('/user/report')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getRecruiterReport = () => {
  return HTTP().get('/user/report/recruiter')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getExportProspectiveStudentsToCsv = () => {
  return HTTP().get('/user/prospectiveStudent/csvExport')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const postSaveProspectiveStudentProfile = (userObj) => {
  return HTTP().post('/user/updateProspectiveStudentProfile', userObj)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}
export const saveADASettingFlag = (userObj) => {
  return HTTP().post('/user/ada/'+userObj.adaEnabled)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getUpgradeToEnhancedWidget = (institutionId) => {
  return HTTP().get('/institution/upgradeToEnhancedWidget/' + institutionId)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getAcceptTermsOfService = (institutionId) => {
  return HTTP().get('/institution/acceptTermsOfService/' + institutionId)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getAcceptTermsOfServiceOffline = (institutionId) => {
  return HTTP().get('/institution/acceptTermsOfServiceOffline/' + institutionId)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getQuestionsForGroup = (group) => {
  return HTTP().get('/qa/group/' + group)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getQuestionsForGroupAndUser = (group, userId) => {
  return HTTP().get('/qa/group/' + group + '/' + userId)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const saveUserProfileAndAnswer = (data) => {
  return HTTP().post('/qa/saveUserProfileAndAnswer', data)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getLearnerDashboardState = () => {
  return HTTP().get('/custom/learner/dashboard')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getChangeUserInstitution = (institutionId) => {
  return HTTP().get('/user/change/institution/'+institutionId)
  .then(res => {
    return res
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}
export const getInpersonateUser = (userId) => {
  return HTTP().get('/user/inpersonate/user/'+userId)
  .then(res => {
    return res
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getAllUserInstitution = (bringMin) => {
  return HTTP().get('/user/all/institution?bringMin='+bringMin)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}
export const getAllUserAccounts = () => {
  return HTTP().get('/user/all/accounts')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getLearnerEnrollmentData = (userId) => {
  let url = '/custom/learner/enrollment'
  if (userId)
    url += '/' + userId
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getNextCalendarEvent = () => {
  return HTTP().get('/calendarEvent/nextCalendarEvent')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}
export const getFeedsForStudent = () => {
  return HTTP().get('/feed/all')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getRecommendationsForStudent = () => {
  return HTTP().get('/channel/student/myChannels/recommendations')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getNotificationsForStudent = () => {
  return HTTP().get('/channel/student/myChannels/notifications')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getCheckTransactionValidity = (programId) => {
  return HTTP().get('/transaction/userTransaction/' + programId + '/validity')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}
export const getAllPurchasePrograms = () => {
  return HTTP().get('/transaction/all/program/')
  .then(res => { 
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getCheckSubscriptionValidity = (programId) => {
  return HTTP().get('/transaction/userTransaction/' + programId + '/validity')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}





// WEBPACK FOOTER //
// ./src/app/dashboard/api.js